import { useMutation, useQueryClient } from '@tanstack/react-query';
import { entityService } from '@/services/EntityService';
import { queryKeys } from '@/lib/queryKeys';

export const useRevertReturnToShelf = () => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, { binIds: string[] }>({
    mutationFn: async ({ binIds }) => {
      await Promise.all(
        binIds.map((id) =>
          entityService.updateEntity(id, {
            entity_data: {
              workflow_status: 'pending_review',
              date_processed: null,
              target_location_id: null,
            },
          }),
        ),
      );
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.bulkInventoryBin.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
    },
  });
};
